import { render, staticRenderFns } from "./AffaireNouvelle.vue?vue&type=template&id=0983fdbf&scoped=true"
import script from "./AffaireNouvelle.vue?vue&type=script&lang=ts"
export * from "./AffaireNouvelle.vue?vue&type=script&lang=ts"
import style0 from "./AffaireNouvelle.vue?vue&type=style&index=0&id=0983fdbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0983fdbf",
  null
  
)

export default component.exports